import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState, useContext, useEffect, useCallback } from 'react';
import Select, { MultiValue, OnChangeValue } from "react-select";
import { OutcomesContext } from '../../pages/outcomes/OutcomesContext';

import { ChoiceOption, OutcomeEvaluation, OutcomeEvaluationAnswer, OutcomesEvaluation, OutcomesQuestion } from '../../utils/Definitions';
import { ValueContainer } from '../ValueContainer';
import { OutcomesQuestionNullSwitch } from './OutcomesQuestionNullSwitch';
import VinelandBehaviorGraphic from '../../images/VinelandBehaviorGraphic.png';
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';

interface Props {
    OutcomeEvaluation: OutcomeEvaluation | null,
    OutcomesQuestion: OutcomesQuestion;
    setOutcomeEvaluationObject: React.Dispatch<React.SetStateAction<OutcomeEvaluation | null>>;
    onChange: any;
    ChildOnChange: any;
    GetText: any;
    NullQuestion: any;
    GetNullValue: any;

}

export const OutcomesQuestionTypeText: React.FC<Props> = (props) => {

    const outcomesContext = useContext(OutcomesContext);

    function IsDisabled(): boolean {
        var nullable = props.OutcomeEvaluation?.nullables.find(x => x.questionID == props.OutcomesQuestion?.question.questionId);
        if (nullable) {
            return nullable.value == "True";
        }
        else {
            return false;
        }
    }

    function ShowVinelandBehaviorGraphic() {
        outcomesContext.setImageModalSource(VinelandBehaviorGraphic);
        outcomesContext.setImageModalActive(true);
    }


    return (
    <div className="grid grid-cols-[1fr_auto] gap-2">
        {/* First Column (grows) */}
        <div
            key={props.OutcomesQuestion?.question.questionId}
            className="w-full xl:w-[38rem] h-fit bg-gray-50 border drop-shadow rounded mt-4 p-2"
        >
            <span className="text-xl font-bold">
                {props.OutcomesQuestion?.question.questionText}
            </span>

            <div className="w-full h-fit m-auto flex">
                {OutcomesQuestionNullSwitch({
                    onChange: props.onChange,
                    OutcomeEvaluation: props.OutcomeEvaluation,
                    OutcomesQuestion: props.OutcomesQuestion,
                    setOutcomeEvaluationObject: props.setOutcomeEvaluationObject,
                    NullQuestion: props.NullQuestion,
                    GetNullValue: props.GetNullValue,
                })}

                <div className="grow">
                    <div key={props.OutcomesQuestion?.question.questionId} className="grow">
                        <input
                            disabled={IsDisabled()}
                            key={props.OutcomesQuestion?.question.questionId}
                            onChange={(event) =>
                                props.ChildOnChange(event.target.value, props.OutcomesQuestion)
                            }
                            value={props.GetText(props.OutcomesQuestion)}
                            autoComplete="off"
                            type="text"
                            className="outline-none h-[38px] border focus:border-2 border-gray-300 text-gray-900 rounded focus:ring-lacblue focus:border-lacblue block w-full p-2.5"
                        />
                    </div>
                </div>
            </div>
        </div>

        {/* Second Column (tiny icon, auto width) */}
        <div
            className={"mt-4 flex items-center " + (props.OutcomesQuestion.question.questionId == 24 ? "" : "hidden")}>
            <div className="cursor-pointer">
                <FontAwesomeIcon onClick={ShowVinelandBehaviorGraphic} className="w-8 h-8 text-lacblue hover:text-lacblue-500" icon={solid("circle-info")}/>
            </div>
        </div>
    </div>
);


}

